(function() {
  'use strict';

  // === Configurações e versão de storage ===
  const MAX_PREF_HOURS = 12;
  const STORAGE_KEYS = {
    preferGlobal: 'preferGlobalSite_v2',           // bumped version
    bannerClosed: 'globalRedirectBannerClosed_v2', // bumped version
    countryInfo: 'geoRedirectCountry'              // pode manter sem versão
  };
  const BANNER_ID     = 'global-redirect-banner';
  const REDIRECT_BASE = 'https://kzmusicstore.com';

  // === Reset das escolhas antigas ao entrar no domínio .com.br ===
  if (window.location.hostname.endsWith('kzmusicstore.com.br')) {
    // remove chaves v1 e v2 para garantir que tudo volte ao estado inicial
    localStorage.removeItem('preferGlobalSite');
    localStorage.removeItem(STORAGE_KEYS.preferGlobal);
    sessionStorage.removeItem('globalRedirectBannerClosed');
    sessionStorage.removeItem(STORAGE_KEYS.bannerClosed);
  }

  // === Traduções ===
  const TRANSLATIONS = {
    en: {
      locationMessage: name => `It looks like you're visiting from <strong>${name}</strong>.`,
      redirectQuestion:    'Would you like to visit our <strong>Global Store</strong>?',
      buttonYes:           'Yes, please!',
      buttonNo:            'No, thanks!'
    },
    pt: {
      locationMessage: name => `Parece que você está visitando de <strong>${name}</strong>.`,
      redirectQuestion:    'Gostaria de visitar nossa <strong>Loja Global</strong>?',
      buttonYes:           'Sim, por favor!',
      buttonNo:            'Não, obrigado!'
    },
    es: {
      locationMessage: name => `Parece que estás visitando desde <strong>${name}</strong>.`,
      redirectQuestion:    '¿Quieres visitar nuestra <strong>Tienda Global</strong>?',
      buttonYes:           '¡Sí, por favor!',
      buttonNo:            '¡No, gracias!'
    },
    // … adicione outros idiomas aqui
  };

  // === Helpers de armazenamento ===
  function saveCountryInfo(code, name) {
    sessionStorage.setItem(STORAGE_KEYS.countryInfo, JSON.stringify({ code, name }));
  }
  function getSavedCountryInfo() {
    const raw = sessionStorage.getItem(STORAGE_KEYS.countryInfo);
    return raw ? JSON.parse(raw) : null;
  }

  function saveGlobalPreference() {
    localStorage.setItem(
      STORAGE_KEYS.preferGlobal,
      JSON.stringify({ ts: Date.now() })
    );
  }
  function hasValidGlobalPreference() {
    const raw = localStorage.getItem(STORAGE_KEYS.preferGlobal);
    if (!raw) return false;
    try {
      const { ts } = JSON.parse(raw);
      return (Date.now() - ts) <= MAX_PREF_HOURS * 3600_000;
    } catch {
      return false;
    }
  }

  // === Gerenciamento do banner ===
  function applyTranslations(locale, countryName) {
    const tr = TRANSLATIONS[locale] || TRANSLATIONS.en;
    document.getElementById('banner-location-message').innerHTML    = tr.locationMessage(countryName);
    document.getElementById('banner-redirect-question').innerHTML = tr.redirectQuestion;
    document.getElementById('banner-button-yes').textContent       = tr.buttonYes;
    document.getElementById('banner-button-no').textContent        = tr.buttonNo;
  }

  function showBanner(countryName) {
    const userLang = (navigator.language || navigator.userLanguage).split('-')[0];
    applyTranslations(userLang, countryName);
    const banner = document.getElementById(BANNER_ID);
    if (banner) banner.style.display = 'block';
  }

  function closeBanner() {
    const banner = document.getElementById(BANNER_ID);
    if (banner) banner.style.display = 'none';
    sessionStorage.setItem(STORAGE_KEYS.bannerClosed, 'true');
  }
  // expõe para onclick inline funcionar
  window.closeBanner = closeBanner;

  // === Geolocalização ===
  async function detectLocation() {
    // 1ª tentativa: ipapi.co
    try {
      const res = await fetch('https://ipapi.co/json/');
      if (res.ok) {
        const { country_code, country_name } = await res.json();
        if (country_code) {
          saveCountryInfo(country_code, country_name);
          return { code: country_code, name: country_name };
        }
      }
    } catch (e) {
      console.error('ipapi.co falhou:', e);
    }
    // 2ª tentativa: ip-api.com
    try {
      const res = await fetch('https://ip-api.com/json/?fields=countryCode,country');
      if (res.ok) {
        const { countryCode, country } = await res.json();
        if (countryCode) {
          saveCountryInfo(countryCode, country);
          return { code: countryCode, name: country };
        }
      }
    } catch (e) {
      console.error('ip-api.com falhou:', e);
    }
    return null;
  }

  // === Inicialização ===
  document.addEventListener('DOMContentLoaded', async () => {
    const banner = document.getElementById(BANNER_ID);
    if (!banner) return;

    // 1) Se já existe preferência válida (≤12h), redireciona diretamente
    if (hasValidGlobalPreference()) {
      return window.location.replace(`${REDIRECT_BASE}${window.location.pathname}`);
    }
    // 2) Se fechou o banner nesta sessão, não exibe de novo
    if (sessionStorage.getItem(STORAGE_KEYS.bannerClosed) === 'true') {
      return;
    }

    // 3) Detecta país (usa cache em sessionStorage)
    let info = getSavedCountryInfo();
    if (!info) {
      info = await detectLocation();
    }
    // 4) Se detectou e não for BR, exibe o banner
    if (info && info.code !== 'BR') {
      showBanner(info.name || info.code);
    }

    // === Handlers dos botões ===
    document.getElementById('banner-button-yes')?.addEventListener('click', () => {
      saveGlobalPreference();
      window.location.replace(`${REDIRECT_BASE}${window.location.pathname}`);
    });
    document.getElementById('banner-button-no')?.addEventListener('click', closeBanner);
    document.querySelectorAll('.banner-close').forEach(btn => {
      btn.addEventListener('click', closeBanner);
    });
  });
})();